import Vue from 'vue'
import Router from 'vue-router'

import Main from '@/views/Main'
const SiteInfoOverlay = () => import('@/components/SiteInfoOverlay')
const SeasonGalleryOverlay = () => import('@/components/SeasonGalleryOverlay')
const LocationOverlay = () => import('@/components/LocationOverlay')

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'index',
      component: Main,
      children: [
        {
          path: 'info',
          name: 'info',
          component: SiteInfoOverlay
        },
        {
          path: 'season/:slug',
          name: 'season',
          component: SeasonGalleryOverlay,
          props: true
        },
        {
          path: 'location/:slug',
          name: 'location',
          component: LocationOverlay,
          props: true
        }
      ]
    }
  ]
})
